import React from 'react';
import { connect } from 'react-redux'

import { saveText, saveEdit } from '../../actions';

import HTMLEditor from "./htmlEditor";

const TextProps = ({ content, onSaveText }) => {
    const [value, setValue] = React.useState(content.config.text);

    const onChange = (id, text) => {
        setValue(text);
        onSaveText(id, text);
    }

    return (
        <div>
            <HTMLEditor text={value} id={content.id} onSaveText={onChange} />
        </div>
    )
}
const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        onSaveText: (rowId, text) => {
            dispatch(saveEdit({ rowId, value: text }))
            dispatch(saveText({ rowId, text }))
        }
    }
}

export default connect(
    null,
    mapDispatchToProps
)(TextProps);